import React from 'react'

import ItemCard from '../itemCard'

const ListDefault = ({items, viewType, currentSite, itemDecorator}) => {
  return (
    <ul className='product-list'>
      {
        items.map((item, index) => {
          return (
            <li key={item.id}>
              <ItemCard
                currentSite={currentSite}
                viewType={viewType}
                itemProps={itemDecorator(item, index)}
              />
            </li>
          )
        })
      }
    </ul>
  )
}

export default ListDefault



// WEBPACK FOOTER //
// ./client/components/productList/listDefault.js